var TabNewDeadlineModule = /** @class */ (function () {
    function TabNewDeadlineModule() {
    }
    return TabNewDeadlineModule;
}());
export { TabNewDeadlineModule };
